import { FunctionsErrorCode } from 'firebase/functions';

interface ErrorCode {
	canonicalCode: number;
	status: number;
}

export interface FunctionsHttpErrorModel {
	code: FunctionsErrorCode;
	details?: Record<string, unknown> & { message: string };
	httpErrorCode: ErrorCode;
}

export class FunctionsHttpError extends Error implements FunctionsHttpErrorModel {
	code: FunctionsErrorCode;
	details?: Record<string, unknown> & { message: string };
	httpErrorCode: ErrorCode;

	constructor(httpError: FunctionsHttpErrorModel) {
		super(httpError.details?.message);
		this.code = httpError.code;

		this.details = httpError.details;
		this.httpErrorCode = httpError.httpErrorCode;
	}
}
